const en_master_profile = {
    "": "profile",
    add: "add profile",
    edit: "edit profile",

    label: {
        name: 'profile name',
    },

    error: {
        name: "Profile name cannot be empty.",
        menu_list: "At least 1 menu access is required.",
        menu_list_min: "At least 1 account item is required to create a menu.",
        create: "Failed to create profile.",
        delete: "Failed to delete profile.",
        edit: "Failed to update profile.",
    },

    success: {
        create: "Profile created successfully.",
        delete: "Profile deleted successfully.",
        edit: "Profile updated successfully.",
    },

    menu: {
        cekgudang: "CHECK WAREHOUSE",
        fasilitas: "FACILITIES",
        fasilitas_daftar_fasilitas: "FACILITIES - FACILITY LIST",
        fasilitas_daftar_permohonan: "FACILITIES - REQUEST LIST",
        fasilitas_kategori_fasilitas: "FACILITIES - FACILITY CATEGORY",
        kontrak: "CONTRACT",
        laporan: "REPORTS",
        laporan_delivery_order: "REPORTS - DELIVERY ORDER",
        laporan_detail_delivery_order: "REPORTS - DELIVERY ORDER DETAIL",
        laporan_detail_penjualan: "REPORTS - SALES DETAIL",
        laporan_detail_sales_order: "REPORTS - SALES ORDER DETAIL",
        laporan_grup: "REPORTS - GROUP",
        laporan_hpp_jual: "REPORTS - COST OF GOODS SOLD",
        laporan_komisi_sales: "REPORTS - SALES COMMISSION",
        laporan_nilai_stock_barang: "REPORTS - INVENTORY VALUE",
        laporan_pembayaran_pembelian: "REPORTS - PURCHASE PAYMENT",
        laporan_pembayaran_penjualan: "REPORTS - SALES PAYMENT",
        laporan_pembelian: "REPORTS - PURCHASE",
        laporan_pengiriman: "REPORTS - DELIVERY",
        laporan_penjualan: "REPORTS - SALES",
        laporan_retur_pembelian: "REPORTS - PURCHASE RETURN",
        laporan_retur_penjualan: "REPORTS - SALES RETURN",
        laporan_sales_order: "REPORTS - SALES ORDER",

        mitra_scm_online: "ONLINE SCM PARTNERS",
        mitra_scm_online_cari_mitra: "ONLINE SCM PARTNERS - FIND PARTNER",
        mitra_scm_online_daftar_mitra: "ONLINE SCM PARTNERS - PARTNER LIST",
        mitra_scm_online_permintaan_barang: "ONLINE SCM PARTNERS - ITEM REQUEST",

        pembayaran: "PAYMENT",
        pembayaran_debit: "PAYMENT - DEBIT",
        pembayaran_kredit: "PAYMENT - CREDIT",

        pembelian: "PURCHASE",
        pembelian_barang_masuk: "PURCHASE - GOODS RECEIVED",
        pembelian_detail_flow_pembelian: "PURCHASE - PURCHASE FLOW DETAIL",
        pembelian_permintaan_penawaran: "PURCHASE - REQUEST FOR QUOTATION",
        pembelian_purchase_order_keluar: "PURCHASE - OUTGOING PURCHASE ORDER",
        pembelian_rekap_tagihan_pembelian: "PURCHASE - PURCHASE BILL SUMMARY",
        pembelian_retur_pemasok: "PURCHASE - SUPPLIER RETURN",
        pembelian_tagihan_pembelian: "PURCHASE - PURCHASE BILL",

        pengaturan: "SETTINGS",
        pengaturan_atribut: "SETTINGS - ATTRIBUTES",
        pengaturan_barang: "SETTINGS - ITEMS",
        pengaturan_gudang: "SETTINGS - WAREHOUSE",
        pengaturan_kategori: "SETTINGS - CATEGORY",
        pengaturan_kategori_keuangan: "SETTINGS - FINANCIAL CATEGORY",
        pengaturan_kebijakan_dan_ketentuan: "SETTINGS - TERMS AND CONDITIONS",
        pengaturan_keuangan: "SETTINGS - FINANCE",
        pengaturan_konversi_barang: "SETTINGS - ITEM CONVERSION",
        pengaturan_kurir: "SETTINGS - COURIER",
        pengaturan_metode_pembayaran: "SETTINGS - PAYMENT METHOD",
        pengaturan_pelanggan: "SETTINGS - CUSTOMER",
        pengaturan_pemasok: "SETTINGS - SUPPLIER",
        pengaturan_pengguna: "SETTINGS - USER",
        pengaturan_profil: "SETTINGS - PROFILE",
        pengaturan_proses: "SETTINGS - PROCESS",
        pengaturan_rekening_bank: "SETTINGS - BANK ACCOUNT",
        pengaturan_ruang_penyimpanan: "SETTINGS - STORAGE",
        pengaturan_sales: "SETTINGS - SALES",
        pengaturan_satuan: "SETTINGS - UNIT",
        pengaturan_tag_barang: "SETTINGS - ITEM TAG",
        pengaturan_tingkat_harga: "SETTINGS - PRICE LEVEL",

        penjualan: "SALES",
        penjualan_daftar_harga_stock: "SALES - PRICE & STOCK LIST",
        penjualan_delivery_order: "SALES - DELIVERY ORDER",
        penjualan_penawaran: "SALES - QUOTATION",
        penjualan_rekap_tagihan_penjualan: "SALES - SALES BILL SUMMARY",
        penjualan_retur_pelanggan: "SALES - CUSTOMER RETURN",
        penjualan_sales_order: "SALES - SALES ORDER",
        penjualan_tagihan_penjualan: "SALES - SALES BILL",

        perencanaan_anggaran: "BUDGET PLANNING",
        perencanaan_anggaran_perencanaan: "BUDGET PLANNING - PLANNING",

        rantai_pasokan: "SUPPLY CHAIN",
        rantai_pasokan_permintaan_barang: "SUPPLY CHAIN - ITEM REQUEST",
        rantai_pasokan_titik_distribusi: "SUPPLY CHAIN - DISTRIBUTION POINT",

        stock_barang: "INVENTORY",
        stock_barang_barang_keluar: "INVENTORY - GOODS OUT",
        stock_barang_barang_masuk: "INVENTORY - GOODS IN",
        stock_barang_nomor_seri: "INVENTORY - SERIAL NUMBER",
        stock_barang_perpindahan_barang: "INVENTORY - ITEM TRANSFER",
        stock_barang_retur_pelanggan: "INVENTORY - CUSTOMER RETURN",
        stock_barang_retur_pemasok: "INVENTORY - SUPPLIER RETURN",

        transaksi_gudang: "WAREHOUSE TRANSACTIONS",
        transaksi_gudang_barang_keluar: "WAREHOUSE TRANSACTIONS - GOODS OUT",
        transaksi_gudang_barang_masuk: "WAREHOUSE TRANSACTIONS - GOODS IN",
        transaksi_gudang_konversi: "WAREHOUSE TRANSACTIONS - CONVERSION",
        transaksi_gudang_perpindahan_barang: "WAREHOUSE TRANSACTIONS - ITEM TRANSFER",
        transaksi_gudang_proses_barang: "WAREHOUSE TRANSACTIONS - ITEM PROCESSING",
        transaksi_gudang_stock_awal: "WAREHOUSE TRANSACTIONS - OPENING STOCK",
        transaksi_gudang_stock_opname: "WAREHOUSE TRANSACTIONS - STOCK OPNAME",
        transaksi_gudang_supervisi_barang_keluar: "WAREHOUSE TRANSACTIONS - GOODS OUT SUPERVISION",
        transaksi_gudang_supervisi_barang_masuk: "WAREHOUSE TRANSACTIONS - GOODS IN SUPERVISION",
        transaksi_gudang_supervisi_retur_pelanggan: "WAREHOUSE TRANSACTIONS - CUSTOMER RETURN SUPERVISION",
        transaksi_gudang_supervisi_retur_pemasok: "WAREHOUSE TRANSACTIONS - SUPPLIER RETURN SUPERVISION",

        AboutScreen: "Info",
        CatalogScreen: "Catalog",
        ClientScreen: "Customer",
        ConversionScreen: "Item Conversion",
        ItemInScreen: "Goods In",
        ItemUseScreen: "Goods Out",
        KonsinyasiScreen: "Consignment",
        ReqMaterialScreen: "Item Request",
        ReqReturnScreen: "Return",
        StockScreen: "Inventory",

        cashier: "Cashier",
        catalog: "Catalog",
        CategoryScreen: "Category Master",
        GoodsScreen: "Item Master",
        IteminScreen: "Goods In",
        ItemoutScreen: "Goods Out",
        reportselling: "Sales Report",
        RequestItemScreen: "Item Request",
        UnitScreen: "Unit Master"
    },
}

export default en_master_profile;